import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { Container, Row, Alert } from 'reactstrap';
import api from '../utils/Api';
import { trackEvent } from '../utils/Analytics';

import bannerLogo from '../images/Jook_Web_White.png';

import './ForgotPasswordView.scss';

interface ForgotPasswordViewProps {}

interface ForgotPasswordViewState {
  error: string;
  success: string;
  email: string;
  loading: boolean;
}

class ForgotPasswordView extends Component<ForgotPasswordViewProps, ForgotPasswordViewState> {
  constructor(props: ForgotPasswordViewProps) {
    super(props);

    this.state = {
      error: '',
      success: '',
      email: '',
      loading: false,
    };
  }

  isValid(): boolean {
    const { email } = this.state;
    let valid = false;

    if (email.length > 0) {
      valid = true;
    }
    if (email.length === 0) {
      this.showError('You must enter an email address');
      valid = false;
    }

    return valid;
  }

  private onSubmit = async (e: React.FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();

    if (!this.isValid()) {
      return;
    }

    const { email } = this.state;

    this.setState({ loading: true });
    api
      .auth('forgot-password', 'POST', {
        email: email,
      })
      .then((response) => {
        trackEvent('password_reset_requested');
        this.showSuccess('Check Email for Reset Link');
        this.setState({ email: '', loading: false });
      })
      .catch((error) => {
        this.setState({ loading: false });
        this.showError(error.message);
        console.log('There has been a problem with your signup operation: ' + error.message);
      });
  };

  showError = (errorText: string) => {
    this.setState({ error: errorText, success: '' });
  };

  showSuccess = (successText: string) => {
    this.setState({ success: successText, error: '' });
  };

  render() {
    return (
      <Container fluid>
        <Row className="public-header-row">
          <div className="col public-header">
            <div className="d-flex justify-content-between">
              <Link to="/">
                <img className="logo" src={bannerLogo} alt="Jookable logo image" />
              </Link>
              <div />
            </div>
          </div>
        </Row>

        <Row className="g-0">
          <div className="col">
            <div className="public-page-content">
              <div className="public-page-formwrapper">
                <h1 className="public-page-formaccess">Recover Password</h1>
                <form onSubmit={this.onSubmit.bind(this)} noValidate className="public-page-form">
                  {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                  {this.state.success && <Alert color="success">{this.state.success}</Alert>}
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={this.state.email}
                    onChange={(e) => this.setState({ email: e.target.value.trim() })}
                  />
                  <button className="button">Reset</button>
                </form>

                <div className="signin-link-wrapper">
                  <Link to="/" className="signin-link">
                    Already have an account
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    );
  }
}

export default ForgotPasswordView;
